module.exports = __webpack_public_path__ + "static/media/wind-mill-grey.472eb116.svg";